function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconMapBillboardYvg9Pf572S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_20-Billboard",
    "data-name": "20-Billboard"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40 55 40 59 24 59 24 55 27 55 37 55 40 55",
    style: {
      fill: "#c1cfe8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 10,
    height: 8,
    style: {
      fill: "#5c6979"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,3V45a2.006,2.006,0,0,1-2,2H13a2.006,2.006,0,0,1-2-2V3a2.006,2.006,0,0,1,2-2H51A2.006,2.006,0,0,1,53,3ZM49,43V5H15V43H49Z",
    style: {
      fill: "#edf4fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,55V53a2.006,2.006,0,0,1,2-2h7a2.006,2.006,0,0,1,2,2,2.015,2.015,0,0,0,2,2h2a2.006,2.006,0,0,1,2,2v2H1V57a2.006,2.006,0,0,1,2-2Z",
    style: {
      fill: "#ff975c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,55V53a2.006,2.006,0,0,1,2-2h2a2.006,2.006,0,0,1,2,2,2.015,2.015,0,0,0,2,2h2a2.006,2.006,0,0,1,2,2v2H48V57a2.006,2.006,0,0,1,2-2Z",
    style: {
      fill: "#ff975c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 14,
    height: 5,
    style: {
      fill: "#4989f4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 14,
    height: 7,
    style: {
      fill: "#4989f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,26H15V21h6.98a3.837,3.837,0,0,1,.22,1.29,1.8,1.8,0,0,0,3.6,0A3.837,3.837,0,0,1,26.02,21H34V5h5V21H49v5H34v7H49v5H34v5H29V38H15V33H29Z",
    style: {
      fill: "#fbcb00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 5,
    width: 10,
    height: 16,
    style: {
      fill: "#01a84e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38,
    width: 15,
    height: 5,
    style: {
      fill: "#01a84e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 26,
    width: 15,
    height: 7,
    style: {
      fill: "#01a84e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,21V5H34V21H26.02c.85-2.51,3.98-3.84,3.98-7.29A5.865,5.865,0,0,0,24,8a5.865,5.865,0,0,0-6,5.71c0,3.45,3.13,4.78,3.98,7.29Z",
    style: {
      fill: "#a8b7d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 14,
    r: 2,
    style: {
      fill: "#96272e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.02,21a3.837,3.837,0,0,0-.22,1.29,1.8,1.8,0,0,1-3.6,0A3.837,3.837,0,0,0,21.98,21C21.13,18.49,18,17.16,18,13.71A5.865,5.865,0,0,1,24,8a5.865,5.865,0,0,1,6,5.71C30,17.16,26.87,18.49,26.02,21ZM26,14a2,2,0,1,0-2,2A2.006,2.006,0,0,0,26,14Z",
    style: {
      fill: "#e63b47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,45H51V3H13Zm2-7V5H49V43H15Z",
    style: {
      fill: "#d6e0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,55V47H37v2H33a3,3,0,0,0-3,3v3Z",
    style: {
      fill: "#393d48"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,55v4H40V57H29a2,2,0,0,1-2-2H24Z",
    style: {
      fill: "#8394b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,11a3,3,0,1,0,3,3A3,3,0,0,0,24,11Zm0,5a2,2,0,1,1,2-2A2.006,2.006,0,0,1,24,16Z",
    style: {
      fill: "#b32e37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.663,38H15v5H29V39A9.944,9.944,0,0,1,24.663,38Z",
    style: {
      fill: "#3f76d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,29V26H15v7h4.838A9.957,9.957,0,0,1,19,29Z",
    style: {
      fill: "#3f76d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.838,33H15v5h9.663A10.019,10.019,0,0,1,19.838,33Z",
    style: {
      fill: "#faab1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 39,
    width: 5,
    height: 4,
    style: {
      fill: "#faab1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 4,
    height: 5,
    style: {
      fill: "#faab1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 39,
    width: 15,
    height: 4,
    style: {
      fill: "#019144"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,16.815a5.38,5.38,0,0,1-1-3.105,5.483,5.483,0,0,1,1-3.151V5H15V21h4Z",
    style: {
      fill: "#8394b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,22.29A3.837,3.837,0,0,0,21.98,21H18.768a6.5,6.5,0,0,1,1.212,2,3.837,3.837,0,0,1,.22,1.29,1.8,1.8,0,0,0,3.6,0c0-.107.018-.2.026-.307A1.746,1.746,0,0,1,22.2,22.29Z",
    style: {
      fill: "#ff9b00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,13.71a5.468,5.468,0,0,1,.784-2.813A5.646,5.646,0,0,0,16,15.71c0,2.431,1.552,3.81,2.768,5.29H21.98C21.13,18.49,18,17.16,18,13.71Z",
    style: {
      fill: "#5c6979"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,55a1,1,0,0,0,0-2,2,2,0,0,1-2-2H6a2.006,2.006,0,0,0-2,2v2h6Z",
    style: {
      fill: "#d67f4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,56a1,1,0,0,1,1-1H3a2.006,2.006,0,0,0-2,2v2H21V57H7A1,1,0,0,1,6,56Z",
    style: {
      fill: "#d67f4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,55a1,1,0,0,0,0-2H54a1,1,0,0,1-1-1V51a2.006,2.006,0,0,0-2,2v2h4Z",
    style: {
      fill: "#d67f4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,56a1,1,0,0,1,1-1H50a2.006,2.006,0,0,0-2,2v2H63V57H54A1,1,0,0,1,53,56Z",
    style: {
      fill: "#d67f4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63 59 63 63 1 63 1 59 21 59 24 59 40 59 48 59 63 59",
    style: {
      fill: "#5c6979"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48 59 45.5 61 63 61 63 59 48 59",
    style: {
      fill: "#393d48"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21 59 19 61 1 61 1 59 21 59",
    style: {
      fill: "#393d48"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24 59 22 61 38 61 40 59 24 59",
    style: {
      fill: "#393d48"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 7.5,
    width: 6,
    height: 1,
    style: {
      fill: "#edf4fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 10.5,
    width: 6,
    height: 1,
    style: {
      fill: "#edf4fa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconMapBillboardYvg9Pf572S);
export default __webpack_public_path__ + "static/media/reshot-icon-map-billboard-YVG9PF572S.0fc9871a23e25b10ab4daa6a01731093.svg";
export { ForwardRef as ReactComponent };